import { Navigate } from 'react-router';
import type { ReactNode } from 'react';
import { useAuth } from './AuthContext';
import { canAccessAppraisals } from './visibility';

/**
 * Route-level gate for the HR ▸ Appraisals subtree (`/hr/appraisals/*`).
 *
 * Appraisals has a broader audience than the rest of HR (which is admin-only
 * via `<RequireTile tile="hr">`): every employee can see their own form,
 * managers see their team, HR/Management see all. So the appraisals subtree
 * mounts ABOVE the admin `/hr/*` route with this dedicated guard, leaving
 * the other HR pages (cash-claims, hot-plate) admin-gated. Closed by default
 * — `canAccessAppraisals(null)` is false.
 */
export function RequireAppraisalsAccess({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  if (!canAccessAppraisals(user)) {
    return <Navigate to="/forbidden" replace />;
  }
  return <>{children}</>;
}
